function export_this_to(sender, type, directExport = true) {
    const serialize = function(obj, prefix) {
        let str = [],
            p;
        for (p in obj) {
            if (obj.hasOwnProperty(p)) {
                const k = prefix ? prefix + "[" + p + "]" : p,
                    v = obj[p];
                str.push((v !== null && typeof v === "object") ?
                    serialize(v, k) :
                    encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
        }
        return str.join("&");
    };

    const $ = jQuery.noConflict();
    const table = $(sender).parents('table:first');
    let url = window.location.toString();
    if(table.is('[data-reloadable-url]')) {
        url = table[0].last_url;
    }
    const export_type = type;
    if ($('.show-for-medium:last(1)').css('display') !== 'none') {
        type = 'fields';
    }
    if(url.split('?').length > 1) {
        url = url+'&export='+type;
    } else {
        url = url+'?export='+type;
    }

    if ($('.show-for-medium:last(1)').css('display') === 'none') {
        window.open(url);
    } else {
        const type = table.attr('data-request-type') === undefined ? 'GET' : table.attr('data-request-type');
        const sendData = type === 'GET' ? {} : table[0].last_data

        $.ajax({
            type: type,
            url: url,
            data: sendData,
            success: function(fields) {
                if (typeof fields === 'object') {
                    const actuallyExport = function(popup = undefined) {
                        url = url + '&export=' + export_type;
                        if (type === 'GET') {
                            window.open(url);
                            if (popup) {
                                popup.close();
                            }
                        } else {
                            const id = get_unique_id();
                            const csrf = $('meta[name="csrf-token"]').attr('content');
                            $('body').append('<form id="' + id + '" method="' + type + '" action="' + url + '" target="_blank">' +
                                `<input type="hidden" name="_token" value="${csrf}" />` +
                                '</form>');
                            const tmpForm = $('#' + id);


                            let addToForm = function(data, prefix) {};
                            addToForm = function(data, prefix) {
                                if (prefix === undefined) {
                                    prefix = '';
                                }
                                Object.keys(data).forEach(function(key) {
                                    if (typeof data[key] === 'object') {
                                        addToForm(data[key], prefix + key);
                                    } else {
                                        let name = key;
                                        console.log(name +  ' = ' + data[key]);
                                        if (prefix.length > 0) {
                                            name = prefix + '[' + name + ']';
                                        }
                                        const input = $('<input />');
                                        input.attr('name', name);
                                        input.attr('value', data[key]);
                                        input.attr('type','text');

                                        tmpForm.append(input);
                                    }
                                });
                            };

                            addToForm(sendData);
                            tmpForm.submit(function() {
                                setTimeout(function() {
                                    // tmpForm.remove();
                                }, 500);
                            });
                            tmpForm.submit();
                        }
                    };

                    if (directExport) {
                        actuallyExport();
                    } else {
                        $.squdeAjaxPopup({
                            url: '/export/screenSettings',
                            type: 'POST',
                            data: serialize(fields),
                            onOpen: function (elm, popup) {
                                const leftSide = elm.find('.list-wrapper.available');
                                const rightSide = elm.find('.list-wrapper.chosen');
                                // elm.find('.check-them-all').change(function() {
                                //     const checked = $(this).is(':checked');
                                //
                                //     leftSide.find('input[type="checkbox"]')
                                //         .prop('checked', checked)
                                //         .trigger('change');
                                // });

                                const fields = [];
                                elm.find('.list-wrapper.available').children().each(function() {
                                    const key = $(this).attr('data-content');
                                    const value = $(this).text().trim();
                                    fields.push(`"${key}|${value}"`);
                                });
                                const fieldsCollection = fields.join('');

                                elm.find('input.search-input').bind('keyup paste', function() {
                                    const input = $(this);
                                    const searchValue = input.val();
                                    const list = input.next();

                                    const listClass = list[0].classList.contains('available') ? 'available' : 'chosen';
                                    const styleId = `export-style-${listClass}`;
                                    $(`head style#${styleId}`).remove();
                                    if (searchValue.length > 0) {
                                        const rx = new RegExp('"([^"]*' + searchValue + '[^"]*)"', 'gi');
                                        const results = [];
                                        let result;
                                        while (result = rx.exec(fieldsCollection)) {
                                            const [key] = result[1].split('|');
                                            results.push(key);
                                        }


                                        const rows = results
                                            .map((field) => {
                                                return `.list-wrapper.${listClass} > .field-option-wrapper[data-content="${field}"]`;
                                            })
                                            .join(', ');

                                        const totalCss = `
                                    .list-wrapper.${listClass} > .field-option-wrapper { display: none; }
                                    ${rows} { display: flex; }`;

                                        const style = $(`<style id="${styleId}" />`);
                                        style.html(totalCss);
                                        $('head').append(style);
                                    } else {
                                        list.children().removeAttr('style');
                                    }
                                });

                                leftSide.find('input[type="checkbox"]').change(function() {
                                    const input = $(this);
                                    const id = input.attr('id').split('/').join('\\/');
                                    const key = id.substring(0, id.length - ('_left').length);

                                    const otherId = `${key}_right`;
                                    const checked = input.is(':checked');
                                    if (checked) {
                                        const fieldOptionWrapper = input.parents('.field-option-wrapper').clone();

                                        if (rightSide.find(`input#${otherId}`).length > 0) {
                                            return;
                                        }

                                        const removeButton = $('<div class="remove-button" />');
                                        const label = fieldOptionWrapper.find('label').clone();
                                        label.html('&times;');
                                        removeButton.html(label);
                                        fieldOptionWrapper.append(removeButton);

                                        const newInput = fieldOptionWrapper.find('input');
                                        const name = input.attr('data-name');

                                        newInput.attr('id', otherId);
                                        newInput.attr('name', name);

                                        fieldOptionWrapper.find('label:first').removeAttr('for');

                                        rightSide.append(fieldOptionWrapper);
                                    } else {
                                        rightSide.find(`input#${otherId}`).parent().remove();
                                    }
                                });

                                rightSide.sortable();

                                elm.find('form').ajaxFormSubmit(() => actuallyExport(popup));
                            }
                        });
                    }
                }
            }
        });
    }
    return false;
}

function direct_export() {
    const $ = jQuery.noConflict();

}

jQuery(document).ready(function($) {
    // export_this_to($('a[title="exporteren"]')[0], 'csv');
});
